import type { FieldValues } from 'react-hook-form';
import { VyDatePicker } from '../../../new-design/date-picker';
import { VyFormField, type VyFormFieldProps } from '../VyFormField';

type VyDateFieldProps<TFieldValues extends FieldValues = FieldValues> = Omit<
  VyFormFieldProps<TFieldValues>,
  'children'
> & {
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
};

export const VyDateField = <TFieldValues extends FieldValues = FieldValues>({
  name,
  disabled,
  control,
  error,
  helperText,
}: VyDateFieldProps<TFieldValues>) => {
  return (
    <VyFormField name={name} control={control} disabled={disabled}>
      {({ ...fieldProps }) => <VyDatePicker {...fieldProps} error={error} helperText={helperText} />}
    </VyFormField>
  );
};
